module.exports = __webpack_public_path__ + "media/images/doctor_profiles/front/search-result/bg_blur-content-1ccdca7f3e5e338a9219ec777e5d16bc.png";